import DOMPurify from 'dompurify';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      sanitize: DOMPurify.sanitize,
    },
  };
});
